import React from 'react';
import { Icon } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';
import { hasMinimumLength } from '@/utils/resultsHelper';
import RequestWorkspaceStatusMessage from './RequestWorkspaceStatusMessage';
import RequestWorspaceIconMessage from './RequestWorspaceIconMessage';
import { requestWorkspaceVerboseStates } from '../constants';
import { workspaceStatus } from '../helper';

const RequestWorkspaceStatus = ({ request }) => {
  const status = workspaceStatus(request);
  const verbose = Object.values(requestWorkspaceVerboseStates).includes(status)
      || (!hasMinimumLength(request.workspace_inbox_url) && !request.workspace_requested);
  const withForm = !verbose && hasMinimumLength(request.workspace_request_form);
  if (!verbose && !withForm) return null;

  return (
    <RequestWorkspaceStatusMessage request={request}>
      {verbose && (<RequestWorspaceIconMessage request={request} verbose icon="info" />)}
      {withForm && (
      <>
        <Icon name="info" />
        <FormattedMessage id="actions.view.request.verbose" />
      </>
      )}
    </RequestWorkspaceStatusMessage>
  );
};

export default RequestWorkspaceStatus;
